import { makeLocalStorable, parseLocalStorable } from '@/utils/localstorable';

const storage: Storage = window.localStorage;

const APP_NAME = 'arya-web';

const LocalStorageService = {
  createKey(key: string, isProtected = false): string {
    return isProtected ? `${APP_NAME}:${key}_protected` : `${APP_NAME}:${key}`;
  },

  get<T>(key: string, isProtected = false): T | undefined {
    const fullKey = this.createKey(key, isProtected);
    if (!Object.prototype.hasOwnProperty.call(storage, fullKey)) {
      return undefined;
    }
    const item = storage.getItem(fullKey);
    if (item === null) {
      return undefined;
    }

    const parsedItem = JSON.parse(item);
    return parseLocalStorable(parsedItem) as T;
  },

  set(key: string, value: any, isProtected = false) {
    if (value === undefined) {
      this.delete(key);
      return;
    }

    storage?.setItem(this.createKey(key, isProtected), JSON.stringify(makeLocalStorable(value)));
  },

  delete(key: string, isProtected = false) {
    storage.removeItem(this.createKey(key, isProtected));
  },

  clear(withProtected = false) {
    Object.keys(storage)
      .filter((key) => key.startsWith(`${APP_NAME}:`) && (withProtected || !key.endsWith('_protected')))
      .forEach((key) => storage.removeItem(key));
  },
};

export default LocalStorageService;
